import React, { createContext, useContext, useState, useCallback } from 'react';
import en from '../locales/en';
import nl from '../locales/nl';

const translations = { en, nl };
const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const [locale, setLocale] = useState('nl'); // Dutch default as requested

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[locale];
    
    for (const k of keys) {
      if (value === undefined) return key;
      value = value[k];
    }
    
    return value || key;
  }, [locale]);

  const toggleLocale = () => {
    setLocale((prev) => (prev === 'nl' ? 'en' : 'nl'));
  };

  return (
    <I18nContext.Provider value={{ locale, setLocale, toggleLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useTranslation must be used within an I18nProvider');
  }
  return context;
};